import React from 'react';
type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}
const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
  primary: 'bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-200',
  success: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  danger: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  info: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
};
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantStyles[variant]} ${className}`} data-id="element-4771">
      {children}
    </span>;
}
export function getStatusBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'programada':
      return 'primary';
    case 'completada':
      return 'success';
    case 'cancelada':
      return 'danger';
    case 'reprogramada':
      return 'warning';
    default:
      return 'default';
  }
}